// utils/custom-trail-canvas.js
import React, { useEffect, useRef } from "react";
import { COLORS } from "../const/colors";
import { cursorTrail } from "./cursor-trail"; // Ensure this path is correct

function CustomTrailCanvas(props) {
  const refCanvas = useRef(null);

  useEffect(() => {
    if (!refCanvas.current) return;

    const { cleanUp, renderTrailCursor } = cursorTrail({
      ref: refCanvas,
      color: COLORS.ORANGE,
    });

    renderTrailCursor();

    return () => {
      cleanUp();
    };
  }, []);

  return (
    <canvas
      ref={refCanvas}
      className={props.className}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 1000,
        ...props.style,
      }}
    />
  );
}

export default CustomTrailCanvas;
